export default __webpack_public_path__ + "1ac82277062cc15cacb825aa47ff2c54.png";